import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // ページ遷移時にトップへスクロール
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export default ScrollToTop;
